import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-tail-biting',
  templateUrl: './tail-biting.component.html',
  imports: [RouterOutlet],
})
export class TailBitingComponent {}
